const getValidators = (field) =>
  Object.keys(field.validators).reduce((result, index) => {
    const validator = field.validators[index]();
    if (validator) {
      result.push(validator);
    }
    return result;
  }, []);

export default getValidators;
